/** Format amount as GBP with exactly two decimal places (e.g. £276.60). */
export function formatGbp(amount) {
  const n = Number(amount);
  if (!Number.isFinite(n)) return '£0.00';
  return `£${n.toFixed(2)}`;
}

/** Numeric amount only, two decimal places (e.g. 276.60). */
export function formatGbpAmount(amount) {
  const n = Number(amount);
  if (!Number.isFinite(n)) return '0.00';
  return n.toFixed(2);
}
